import { LoginFlow, Session } from '@ory/client';
import { getCSRFToken } from './CSRFToken';

export interface ISAMLLoginSettings {
  csrfToken: string;
  flowId: string;
  providerId: string;
}

export function getSAMLLoginFlow(response: LoginFlow): ISAMLLoginSettings | undefined {
  const SAMLNodes = response.ui.nodes.filter((node) => node.group === 'saml');
  const csrfToken = getCSRFToken(response);
  const flowId = response.id;

  if (SAMLNodes) {
    for (const node of SAMLNodes) {
      if (node.attributes.node_type === 'input' && node.attributes.name === 'provider') {
        return {
          csrfToken,
          flowId,
          providerId: node.attributes.value,
        };
      }
    }
  }
  return undefined;
}

export function isSessionAuthenticatedViaSaml(session: Session): boolean {
  return !!session.authentication_methods?.find((method) => (method.method as string) === 'saml');
}
